import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { OptionsService } from '../../options/services/options.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { setThromScreenOptions } from '../store/options.actions'

export function* getThromScreenOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)

  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getThromScreenOptions])
    const { entity } = response
    yield put(setThromScreenOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getThromScreenOptions() error: ${e}`))
  }
}

export function* getThromScreenOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getThromScreenOptions)
}
